import { memo, useMemo } from "react";
import "./paper-sheet.css";
import { toBn } from "@/lib/format";

// প্রতিটা কার্ডের মলাট: ছোট একটা A4 শিট — প্রতিষ্ঠান, পরীক্ষা, শ্রেণি/বিষয় আসল তথ্য থেকে; নিচের প্রশ্নের
// দাগগুলো কাগজের স্লাগ থেকে স্থির ভাবে তৈরি (একই পেপার সবসময় একই দেখায়, আলাদা পেপার আলাদা)।
// ডাটাবেস থেকে পুরো paper_json না এনেও (egress বাঁচিয়ে) তালিকায় "কাগজ" অনুভূতি দেওয়ার জন্য।
// আসল প্রিভিউ পেপারের পেজে।

function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function seeded(seed) {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function buildRows(key) {
  const rand = seeded(hash(key));
  const marks = [2, 3, 5, 10];
  return Array.from({ length: 10 }, (_, i) => {
    const mcq = rand() < 0.42;
    return {
      n: i + 1,
      mcq,
      w1: Math.round(66 + rand() * 34),
      w2: Math.round(34 + rand() * 46),
      mark: mcq ? 1 : marks[Math.floor(rand() * marks.length)],
    };
  });
}

function PaperSheet({ seed, institution, exam, classLabel, subjectLabel, className = "" }) {
  const rows = useMemo(() => buildRows(String(seed ?? "paper")), [seed]);
  const meta = [classLabel && `শ্রেণি: ${classLabel}`, subjectLabel && `বিষয়: ${subjectLabel}`].filter(Boolean).join("  |  ");

  return (
    <div className={`psheet ${className}`} aria-hidden="true">
      <div className="psheet__stripe" />
      <div className="psheet__in">
        <div className="psheet__inst">{institution || "প্রশ্নপত্র"}</div>
        {exam && <div className="psheet__exam">{exam}</div>}
        {meta && <div className="psheet__meta">{meta}</div>}
        <div className="psheet__rule" />
        {rows.map((r) => (
          <div className="psheet__row" key={r.n}>
            <span className="psheet__num">{toBn(r.n)}।</span>
            <div className="psheet__lines">
              <i style={{ width: `${r.w1}%` }} />
              {r.mcq ? (
                <div className="psheet__opts">
                  <b />
                  <b />
                  <b />
                  <b />
                </div>
              ) : (
                <i style={{ width: `${r.w2}%` }} />
              )}
            </div>
            <span className="psheet__mk">{toBn(r.mark)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(PaperSheet);
